const uploadMessagesStyle = {
  float: 'right',
  textAlign: 'right',
  color: 'white',
  marginTop: '20px',
  marginRight: '20px',
  pointerEvents: 'none',
  maxHeight: 'calc(100vh - 231px)',
  overflow: 'hidden',
  fontSize: '125%'
}

const uploadMessagesStyleRow = {
  padding: '20px',
  background: 'rgb(89,185,108)',
  marginTop: '8px',
  borderRadius: '10px',
}

export {uploadMessagesStyle, uploadMessagesStyleRow}
